/**
 * URL base da API (baked via REACT_APP_API_URL no build).
 *
 * - Dev: vazio → proxy local (setupDevProxy.cjs).
 * - Testes: REACT_APP_API_URL em `.env.test` (carregado pelo Vitest).
 * - Staging/prod: obrigatória (validada no `vite build`).
 */
export function getApiBaseUrl(): string {
  const apiUrl = (process.env.REACT_APP_API_URL ?? '').trim();

  if (process.env.NODE_ENV === 'production' && !apiUrl) {
    throw new Error(
      'REACT_APP_API_URL não definida. O build deve incluir esta variável (.env.staging / .env.prod).'
    );
  }

  return apiUrl;
}
